import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CovidProtection from "./component";
import { withRouter } from "react-router-dom";
import { updateLeadSource } from "../settings/actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateLeadSourceConnect: updateLeadSource
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CovidProtection));
